module.exports = __webpack_public_path__ + "static/media/desktopScreenshot02.830d6174.jpg";